import { useRef, useState } from "react";
import { Link } from 'react-router-dom'
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "..";
import Loading from "./components/Loading";

const SignIn = () => {

    const email = useRef(null);
    const password = useRef(null);
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
  
    // ログイン処理
    const handleSubmit = async (e) => {
      e.preventDefault();
      console.log(email.current.value, password.current.value);
  
      try {
        await signInWithEmailAndPassword(auth, email.current.value, password.current.value);
        // ログイン成功時の処理 (e.g., ホームページへリダイレクト)
        setShowError(false);
        // ホーム にリダイレクト
        navigate('/');
      } catch (error) {
        // ログイン失敗時の処理
        setShowError(true);
        setLoading(false);
      }
    }

    // パスワードリセット
    const resetPassword = async () => {
      try {
        await sendPasswordResetEmail(auth, email.current.value);
        alert('パスワードリセットメールを送信しました。');
      } catch (error) {
        console.error('パスワードリセット失敗:', error);
        alert('メールの送信に失敗しました。');
      }
    }


  return (
    <div className="text-center my-6 mx-3">
      <Loading show={loading} text="ログイン中..." />

      <div className="py-5">
        <h1 className="text-4xl tracking-widest mb-3">電鬼 2</h1>
        <p className="text-lg text-gray-500">大規模鬼ごっこ運営Webアプリ</p>
      </div>

      {/* ログインフォーム */}
      <form className="md:w-1/3 mx-auto my-6 p-6 bg-white rounded-3xl shadow" onSubmit={(e) => {setLoading(true);handleSubmit(e)}}>
        <h2 className="text-center text-2xl mb-4 ">ログイン</h2>

        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            メールアドレス
          </label>
          <input type="email" id="email" name="email" ref={email} className="mt-1 p-2 w-full border border-gray-300 rounded-md" />
        </div>
        <div className="mb-6">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">
            パスワード
          </label>
          <input type="password" id="password" name="password" ref={password} className="mt-1 p-2 w-full border border-gray-300 rounded-md mb-1" />
          <Link onClick={() => resetPassword()} className="text-blue-500 hover:underline text-sm">パスワードを忘れた方はこちら</Link>
        </div>

        <div className={"mb-6 text-red-600 text-sm " + (!showError && "hidden")}>
          <p>ログインに失敗しました。入力内容に間違いはありませんか？</p>
        </div>

        <button type="submit" className="w-full p-2 bg-purple-500 text-white rounded-md hover:bg-purple-700"><i className="bi bi-key me-2"></i>ログイン</button>

        <hr className="bg-gray-200 my-5" />

        {/* サインアップ */}
        <Link to="/signUp" className="text-blue-500 hover:underline">アカウントをお持ちでない方はこちら</Link>
      </form>

    </div>
  )
}

export default SignIn